module.exports = __webpack_public_path__ + "static/media/carrinho.8eb76e99.png";